import HurryUp from './HurryUp';

export default HurryUp;